import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FleetService } from '../../fleet-service/fleet.service';
import { sweetAlert } from 'src/app/utils/swal';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';

@Component({
  selector: 'app-add-late-onscene-reason',
  templateUrl: './add-late-onscene-reason.component.html',
  styleUrls: ['./add-late-onscene-reason.component.css']
})
export class AddLateOnsceneReasonComponent implements OnInit {
  onSceneReasonForm: FormGroup;
  submitted: any = false;
  lateReasonId: any
 
 
  constructor(
    private FleetService: FleetService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
  ) { }

  ngOnInit() {
    this.activatedRoute.params
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe((params) => {
      this.lateReasonId = params["id"];
   
    });   
     this.onSceneReasonForm = this.fb.group({
      reason: ["", Validators.required],
      sort: ["", Validators.required],
      description: ["",Validators.required],
      status : ["active", Validators.required]
    });
    if(this.lateReasonId){
      this.getLateReason()
    }
  }

  getLateReason(){
    this.FleetService.getLateReasonById(this.lateReasonId)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {
          this.onSceneReasonForm.patchValue(data)
        }
      },
      (err) => {
        sweetAlert("Error", err, "error", "Ok");
      }
    );
  }

  saveReason() {
    this.submitted = true;
    if (this.onSceneReasonForm.invalid) {
      return;
    }
      let payload = this.onSceneReasonForm.value;
      this.FleetService.saveLateReasons(payload,this.lateReasonId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.router.navigateByUrl("fleet/late-reasons");
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }


  get form() {
    return this.onSceneReasonForm.controls;
  }

  ngOnDestroy(): void {
  }
}
